import Image from "../../../../src/components/ProfileImage";
import * as React from 'react';
export default {
  Image,
  React
};